import { ButtonProps, LoadingSpinnerProps } from 'spindl-shared-components';
import { TableColumnTitleProps } from '../../molecules/TableColumnTitle';
import { TableRowListProps } from '../../molecules/TableRowList';


type TableInternalProps = {
  tableColumnTitle?: TableColumnTitleProps;
  tableRowList?: TableRowListProps;
  button?: ButtonProps;
  loadingSpinner?: LoadingSpinnerProps; // MANUAL OVERRIDE
};

type TablePropsValues = {
  '': TableInternalProps;
};

const propValues: TablePropsValues = {
  '': {
    tableColumnTitle: {
    },
    tableRowList: {
    },
    // MANUAL OVERRIDE
    loadingSpinner: {
      size: 'Large',
      styleType: 'Primary',
    },
    button: {
      type: 'FieldIcon',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
  },
};

const getProps = (type: string): TableInternalProps => {
  const values: TableInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
